export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/PolicyIcon.8eb12356.svg","height":123,"width":116,"blurWidth":0,"blurHeight":0};